// Fachada do gateway Realtime — método da instância (ver core.ts).
import { realtimeGateway } from './core';

export const subscribeToTable = realtimeGateway.subscribeToTable;
export const getRealtimeConnectionState = realtimeGateway.getConnectionState;

export type { SubscribeTableParams, RealtimeChange } from '@modules/realtime';
